const ApiRoutes = {
    otpSend: "/auth/send-otp",
    verifyOtp:"/auth/verify-otp",
    reSendOtp:"/auth/resend-otp",
    getAudits:"/master/search",
    getmyAudits:"/audit/eca/mine",
    getViewAudit:"/audit",
    cancelAudits:"/audit",
    acceptAudit:"/audit/approve",
    rejectAudit:"/audit/reject",
    partialApproveAudit:"/audit/partial-approve",
    getRrb:"/master/rrb",
    getCity:"/master/cities",
    getCentres:"/master/centre",
    getStates:"/master/states",
    getCen:"/master/cen",
    addCen:"/master/cen",
    editCen:"/master/cen",
    deleteCen:"/master/cen",
    getAdmins:"/user/admin",
    addAdmin:"/user/create-admin",
    editAdmin:"/user/update-user",
    deleteAdmin:"/user",
    getUsers:"/user",
    addUser:"/user/create-user",
    deleteUser:"/user",
    userBlockUnBlock:"/user/update-status",
    getDashboard:"/reports/dashboard",
    getCentreData:"/master/centre",
    addCentre:"/master/centre",
    editCentre:"/master/centre",
    deleteCentre:"/master/centre",
    getRrbData:"/master/rrb",
    addRrb:"/master/rrb",
    editRrb:"/master/rrb",
    deleteRrb:"/master/rrb",
    getStateData:"/master/states",
    addState:"/master/state",
    editState:"/master/state",
    deleteState:"/master/state",
    getCityData:"/master/cities",
    addCity:"/master/city",
    editCity:"/master/city",
    deleteCity:"/master/city",
    downloadPdf:"/audit/download",
    getAuditsQuestions:"/questions",
    addAuditQuestion:"/questions",
    editAuditQuestion:"/questions",
    deleteAuditQuestion:"/questions",
    reoderAuditQuestion:"/questions/sequence",
    getAuditsImages:"/questions/media-question",
    addAuditImages:"/questions/media-question",
    editAuditsImages:"/questions/media-question",
    deleteAuditImages:"/questions/media-question",
    getAuditsFormExtras:"/questions/signature-question",
    addAuditsFormExtras:"/questions/signature-question",
    editAuditsFormExtras:"/questions/signature-question",
    deleteAuditFormExtras:"/questions/signature-question",
    getSupportTicket:"/support_tickets",
    editSupportTicket:"/support_tickets/update",
    addStartEcaAudit:"/audit/eca-start",
    saveEcaAudit:"/audit/eca-save",
    getReAudit:"/audit/re-audit-requests",
    editReAudit:"/audit/re-audit-requests",
    copyAudits:"/audit/duplicate",
    auditHistory: "/audit/history",
    getAnnouncement:"/announcement",
    addAnnouncement:"/announcement"
  };
  
  export default ApiRoutes;